
import Vue from 'vue'
import {ListingDetailInterface, ChefPricingInterface, ChefPricingRequestInterface} from '~/store/listing'
import {mapGetters} from 'vuex'
import {formatInputData} from '~/util/format-filter-data'
import {updateQueryParams} from '~/util/query-parser'
import {ExtraSelectedInterface} from '~/components/chef/extra-card.vue'
import {EVENT_CHANGE_DATA} from '~/util/event-bus'

export default Vue.extend({
  name: 'ChefPricingCard',
  props: {
    chefId: {
      type: String,
      default: '',
      required: true
    },
  },
  computed: {
    ...mapGetters({
      filter: 'filter/filter',
      extraById: 'listing/extraByListingId'
    }),
    selectedExtras(): { id: number, quantity: number }[] {
      return ((this.extraById(this.chef.id) ?? []) as ExtraSelectedInterface[]).filter(option => option && option.value > 0).map(option => {
        return {
          id: option.id,
          quantity: option.value,
        }
      })
    },
    error(): string | undefined {
      if (this.filter.address === undefined) {
        return 'Vul een adres in'
      }

      if (this.filter.calendar === undefined) {
        return 'Vul een datum in'
      }

      if ((this.filter.person ?? 0) < (this.chef?.min_guests ?? 2)) {
        return this.$t('chef.error.min-guests', {
          guests: this.chef?.min_guests ?? 2
        }) as string
      }

      if ((this.filter.person ?? 0) > (this.chef?.max_guests ?? 30)) {
        return this.$t('chef.error.max-guests', {
          guests: this.chef?.max_guests ?? 30
        }) as string
      }

      return this.errorMessage
    },
    chef(): ListingDetailInterface {
      return this.$store.getters['listing/byIdOrSlug'](this.chefId)
    },
    price(): ChefPricingInterface {
      return this.$store.getters['listing/pricingByListingId'](this.chef.id)
    },
  },
  data() {
    return {
      timeOut: 0,
      errorMessage: undefined
    }
  },
  async mounted() {
    this.fetchPricingWithTimeout();

    this.$nuxt.$on(EVENT_CHANGE_DATA, () => {
      this.fetchPricingWithTimeout();
    })
  },

  beforeDestroy() {
    this.$nuxt.$off(EVENT_CHANGE_DATA)
  },
  methods: {
    fetchPricingWithTimeout(timeout: number = 500) {
      if (this.timeOut) {
        clearTimeout(this.timeOut)
      }

      // @ts-ignore
      this.timeOut = setTimeout(async () => {
        this.errorMessage = undefined
        if (this.error === undefined) {
          await this.fetchPricing()
        }
      }, timeout)
    },
    calculatePrice() {
      this.$nuxt.$emit('calculatePrice')
    },
    quotation() {
      this.$router.push({
        path: `/chef/${this.chefId}/quotation/`,
        query: updateQueryParams({
          ...this.filter,
          selectedExtras: this.selectedExtras
        })
      })
    },
    reserveNow() {
      this.$router.push({
        path: `/chef/${this.chefId}/book/`,
        query: updateQueryParams({
          ...this.filter,
          selectedExtras: this.selectedExtras
        })
      })
    },
    async fetchPricing() {
      await this.$router.push({
        query: updateQueryParams({
          ...this.filter,
          selectedExtras: this.selectedExtras
        })
      })

      try {
        await this.$store.dispatch('listing/calculateChefPrice', {
          id: this.chef.id,
          data: {
            ...formatInputData(this.filter),
            coupon: '',
            extras: this.selectedExtras
          } as ChefPricingRequestInterface
        })

        this.errorMessage = undefined
      } catch (e) {
        // @ts-ignore
        if (e.isAxiosError) {
          // @ts-ignore
          this.errorMessage = e.response?.data?.message ?? 'Er ging iets mis'
        }
      }
    }
  }
})
